module.exports = __webpack_public_path__ + "img/horizontal_arrow.0c153491.svg";